import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../ui/button';

interface Props {
  title: string;
  description?: string;
  back?: { to: string; label: string };
  actions?: ReactNode;
}

export function PageHeader({ title, description, back, actions }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="min-w-0">
        {back && (
          <Button asChild variant="ghost" size="sm" className="-ml-3 mb-1 h-7 px-2 text-text-muted">
            <Link to={back.to}>
              <ChevronLeft className="h-4 w-4" />
              {back.label}
            </Link>
          </Button>
        )}
        <h2 className="truncate text-2xl font-bold tracking-tight text-text">{title}</h2>
        {description && <p className="mt-1 text-sm text-text-muted">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
